import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalContext } from '../context/GlobalContext';
import { LogOut } from 'lucide-react';

const Logout = () => {
  const { siteInfo, currentLang, loading, error } = useGlobalContext();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="text-center">
        <p>{t('Chargement...')}</p>
      </div>
    );
  }

  if (error || !siteInfo) {
    return (
      <div className="text-center">
        <p>{t('Une erreur est survenue')}</p>
      </div>
    );
  }

  const titleText = t('Vos bons d\'achat {{ siteInfo.libelle }}', { 
    'siteInfo.libelle': siteInfo.libelle || '' 
  });

  const getInfoText = () => {
    const baseText = t('Si vous souhaitez à nouveau la liste de vos bons d\'achat {{ siteInfo.libelle }}, veuillez procéder à une <a href="home">nouvelle demande d\'accès</a>', {
      'siteInfo.libelle': siteInfo.libelle || ''
    });
    return baseText;
  };

  return (
    <div id="logout" className="text-center">
      <h1>{titleText}</h1>
      <div>
      <div><span className="glyphicon glyphicon-log-out"></span> </div>

        <h3>{t('Vous êtes déconnecté')}</h3>
        
        <p dangerouslySetInnerHTML={{ __html: getInfoText() }} />
      </div>
    </div>
  );
};

export default Logout;